














































import Vue from 'vue'
import Person from '@/types/Person.interface'
import { mapGetters } from 'vuex'
import printer from '@/plugins/printer'
export default Vue.extend({
    mounted() {
        if (!this.printQueue) {
            this.$store.commit('printQueueLoad')
        }
    },
    computed: { ...mapGetters(['appDrawer', 'printQueue']) },
    methods: {
        printQueueClear(): void {
            this.$store.commit('printQueueClear')
            // if (this.appDrawer === true) {
            //     this.$store.commit('appDrawerToggle')
            // }
            this.$emit('clear')
        },
        printQueuePrint(): void {
            printer.printQueuePrint()
            this.$emit('clear')
        },
        printQueueRemove(person: Person): void {
            this.$store.commit('printQueueRemove', person)
            if (this.printQueue.length === 0 && this.appDrawer === true) {
                this.$store.commit('appDrawerToggle')
            }
        }
    }
})
